<template>
  <reset-password :settings="settings" />
</template>

<script>
import ResetPassword from '../../components/ResetPassword.vue';

export default {
  name: 'RequestedUpdatePassword',

  components: {
    ResetPassword,
  },

  computed: {
    settings() {
      return this.$store.state.partners.currentPartner.settings.sections
        .update_password_page.update_password;
    },
  },
};
</script>
